import Resource from './Resource';

export default class Accounts extends Resource {
	constructor(options={}) {
		let {} = options;

		let config = {
			route: 'schools'
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
